<template>
    <v-container fluid>
      <h1>Intro Buttons</h1>
      <div class="intro-buttons">
        <div class="card-curvey delete-wrapper" v-for="(buttons,index) in list">
          <buttons-list :list-data="buttons.body" @updateList="updateButtons(buttons)"/>
          <v-btn
              @click="deleteList(buttons)"
              fab small color=""
              class="delete-button"
          ><v-icon small color="#666">delete_outline</v-icon></v-btn>
        </div>
        <v-btn
            large round flat block
            class="primary--text"
            @click="addList"
        >
          <v-icon>add_circle_outline</v-icon>
          Add New Form
        </v-btn>
      </div>
    </v-container>
</template>

<script>
import common from "../../../../utils/common";
import buttonsList from "./buttonsList";
export default {
  name: "introButtons",
  components: {
    buttonsList
  },
  data() {
    return {
      list: [],
      buttonTypeList: ['block', 'url', 'phone'],
      blocksList: []
    }
  },
  mounted() {
    this.getButtonsList()
  },
  methods: {
    getButtonsList() {
      this.$store.dispatch('setLoader' , true)
      this.$http_bot.get('/bot_objects/intro-buttons')
          .then(response=>{
            this.list = response.data
          })
          .catch(error=>{
            if (error.response.status === 401) {
              common.logOut()
            }
          })
      .finally(()=>{
        this.$store.dispatch('setLoader' , false)
      })
    },
    addList() {
      this.$http_bot.post(`/bot_objects/intro-buttons`,{
        bot_id: this.$store.state.bot.botId,
        body: {
          locale: "",
          buttonsList: [],
          label: ''
        },
        active: true
      })
          .then(res=>{
            this.list.push(res.data)
          })
          .catch(error=>{
            if (error.response.status === 401) {
              common.logOut()
            }
          })
    },
    deleteList (buttons) {
      this.$store.dispatch('setLoader', true)
      this.$http_bot.delete(`/bot_objects/intro-buttons/${buttons.id}`)
      .then(res=>{
        this.getButtonsList()
      })
      .catch(err=>{

      })
      .finally()
    },
    updateButtons(buttons) {
      this.$http.put(`/bot_objects/intro-buttons/${buttons.id}`,buttons)
      .then(res=>{

      })
      .catch(error=>{
        if (error.response.status === 401) {
          common.logOut()
        }
      })
    },
    throttleUpdate: common.throttle(async function () {
      await this.updateButtons();
    }, 4000),
  },
  watch: {
    buttonsList: {
      handler() {
          this.throttleUpdate()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.card-inner-wrapper {

}
</style>
